import { Fragment } from "react"
import classNames from "classnames"
import { observer } from "mobx-react"
import { useStore, FooterBorder } from "@features/common"
import { LanguageSwitcher } from "@features/i18n"
import { HamburgerButton } from "@ui"

import { Logo } from "../molecules"

import type { ReactElement } from "react"

type HeaderProps = {
  languageSwitcher?: ReactElement<typeof LanguageSwitcher> | null
  logo?: ReactElement | null
  navigationOpener?: ReactElement<typeof HamburgerButton> | null
  searchOpener?: ReactElement | null
  theme?: "light" | "dark" | "black"
}

export const Header = observer(function Header(props: HeaderProps) {
  const {
    GlobalModel: { openMenu },
  } = useStore()
  const {
    languageSwitcher = <LanguageSwitcher />,
    logo = <Logo />,
    searchOpener,
    navigationOpener = <HamburgerButton onClick={openMenu} />,
    theme = "light",
  } = props

  return (
    <header
      className={classNames(
        "w-full flex",
        theme === "light" && "bg-white h-16 tablet:h-20 laptop:h-22",
        theme === "dark" && "bg-gray-400 relative h-13 tablet-m:h-18",
        theme === "black" && "bg-black relative h-13 tablet-m:h-18",
      )}
      data-test-id="header"
    >
      <div
        className={classNames(
          "flex items-center justify-between select-none",
          theme === "light"
            ? "container"
            : "w-full px-4 tablet-m:px-10 laptop:px-20",
        )}
      >
        {logo}
        <div className="space-x-3 flex items-center justify-end tablet-m:space-x-4 laptop:space-x-6">
          <Fragment>{languageSwitcher}</Fragment>
          {searchOpener}
          {navigationOpener}
        </div>
      </div>
      {theme === "dark" && (
        <FooterBorder className="h-2 w-full text-gray-400 absolute top-full" />
      )}
      {theme === "black" && (
        <FooterBorder className="h-2 w-full text-black absolute top-full" />
      )}
    </header>
  )
})
